import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { TbArrowLeft } from "react-icons/tb";

import { STEPS } from "@/features/BillingOnboardingModal/BillingOnboardingModal.constants";

import NextButton from "./NextButton";
import { ButtonContainer } from "./StepButtons.styles";
import SubmitButton from "./SubmitButton";

type TStepButtonsProps = {
  nextStep: () => void;
  prevStep: () => void;
  currentStep: number;
};

function StepButtons({
  prevStep,
  nextStep,
  currentStep,
}: TStepButtonsProps) {
  const { t } = useTranslation();

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === STEPS.length - 1;

  return (
    <ButtonContainer $justifyFlexEnd={isFirstStep}>
      {!isFirstStep && (
        <Button
          onClick={prevStep}
          icon={<TbArrowLeft />}
        >
          {t("prevStep")}
        </Button>
      )}
      {isLastStep
        ? <SubmitButton />
        : <NextButton nextStep={nextStep} />}
    </ButtonContainer>
  );
}

export default StepButtons;
